import { DEFAULT_LANG } from './i18n.js';
/**
 * Xatolik kodlari — backend va frontend uchun umumiy.
 *
 * BT §7.4: foydalanuvchiga tushunarli xabar ko'rsatiladi, texnik stack-trace emas.
 * Har bir kodning matni ikki tilda — o'zbekcha va ruscha.
 */
export const ErrorCode = {
    // Umumiy
    INTERNAL: 'INTERNAL',
    VALIDATION: 'VALIDATION',
    NOT_FOUND: 'NOT_FOUND',
    RATE_LIMITED: 'RATE_LIMITED',
    // Auth
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    // MyID
    MYID_FAILED: 'MYID_FAILED',
    MYID_LOW_COMPARISON: 'MYID_LOW_COMPARISON',
    // Scoring
    SCORING_IN_PROGRESS: 'SCORING_IN_PROGRESS',
    SCORING_ALL_REJECTED: 'SCORING_ALL_REJECTED',
    PROVIDER_UNAVAILABLE: 'PROVIDER_UNAVAILABLE',
    PROVIDER_TIMEOUT: 'PROVIDER_TIMEOUT',
    PROVIDER_NOT_SELECTABLE: 'PROVIDER_NOT_SELECTABLE',
    INVALID_STATE_TRANSITION: 'INVALID_STATE_TRANSITION',
    // OTP
    OTP_INVALID: 'OTP_INVALID',
    OTP_EXPIRED: 'OTP_EXPIRED',
    OTP_ATTEMPTS_EXCEEDED: 'OTP_ATTEMPTS_EXCEEDED',
    // Shartnoma
    AMOUNT_EXCEEDS_LIMIT: 'AMOUNT_EXCEEDS_LIMIT',
    CONTRACT_FAILED: 'CONTRACT_FAILED',
    // Konfiguratsiya (kalitlar hali kelmagan)
    ADAPTER_NOT_CONFIGURED: 'ADAPTER_NOT_CONFIGURED',
    NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',
};
/** Foydalanuvchiga ko'rsatiladigan matnlar (BT §7.4). */
const ERROR_MESSAGES_UZ = {
    INTERNAL: 'Tizimda kutilmagan xatolik yuz berdi. Iltimos, keyinroq urinib ko\'ring.',
    VALIDATION: "Ba'zi maydonlar to'g'ri to'ldirilmagan — ular qizil bilan belgilandi.",
    NOT_FOUND: 'So\'ralgan ma\'lumot topilmadi.',
    RATE_LIMITED: "Juda ko'p so'rov yuborildi. Biroz kuting.",
    UNAUTHORIZED: 'Tizimga kirish talab etiladi.',
    FORBIDDEN: 'Bu amalni bajarishga ruxsatingiz yo\'q.',
    INVALID_CREDENTIALS: "Telefon raqami yoki parol noto'g'ri.",
    TOKEN_EXPIRED: 'Sessiya muddati tugadi. Qaytadan kiring.',
    MYID_FAILED: 'Identifikatsiya o\'tmadi. Iltimos, qaytadan urinib ko\'ring.',
    MYID_LOW_COMPARISON: 'Yuz tasviri hujjatdagi rasm bilan yetarlicha mos kelmadi. Qaytadan urinib ko\'ring.',
    SCORING_IN_PROGRESS: "So'rov allaqachon yuborilgan, natijani kuting.",
    SCORING_ALL_REJECTED: 'Afsuski, hech bir provayder tasdiqlamadi.',
    PROVIDER_UNAVAILABLE: 'Provayder vaqtincha ishlamayapti.',
    PROVIDER_TIMEOUT: 'Provayder javob bermadi.',
    PROVIDER_NOT_SELECTABLE: 'Bu provayderni tanlab bo\'lmaydi.',
    INVALID_STATE_TRANSITION: 'Amalni bajarib bo\'lmaydi — ariza holati mos emas.',
    OTP_INVALID: "Kod noto'g'ri kiritildi.",
    OTP_EXPIRED: 'Kod muddati tugadi. Yangi kod so\'rang.',
    OTP_ATTEMPTS_EXCEEDED: "Urinishlar soni tugadi. Yangi kod so'rang.",
    AMOUNT_EXCEEDS_LIMIT: 'Summa tasdiqlangan limitdan oshib ketdi.',
    CONTRACT_FAILED: 'Shartnoma tuzishda xatolik yuz berdi.',
    ADAPTER_NOT_CONFIGURED: 'Provayder integratsiyasi hali sozlanmagan.',
    NOT_IMPLEMENTED: 'Bu imkoniyat hali ishlab chiqilmagan.',
};
const ERROR_MESSAGES_RU = {
    INTERNAL: 'Произошла непредвиденная ошибка. Попробуйте позже.',
    VALIDATION: 'Некоторые поля заполнены неверно — они отмечены красным.',
    NOT_FOUND: 'Запрошенные данные не найдены.',
    RATE_LIMITED: 'Слишком много запросов. Немного подождите.',
    UNAUTHORIZED: 'Требуется вход в систему.',
    FORBIDDEN: 'У вас нет прав на это действие.',
    INVALID_CREDENTIALS: 'Неверный номер телефона или пароль.',
    TOKEN_EXPIRED: 'Сессия истекла. Войдите заново.',
    MYID_FAILED: 'Идентификация не пройдена. Попробуйте ещё раз.',
    MYID_LOW_COMPARISON: 'Лицо недостаточно совпало с фото в документе. Попробуйте ещё раз.',
    SCORING_IN_PROGRESS: 'Запрос уже отправлен, дождитесь результата.',
    SCORING_ALL_REJECTED: 'К сожалению, ни один провайдер не одобрил.',
    PROVIDER_UNAVAILABLE: 'Провайдер временно недоступен.',
    PROVIDER_TIMEOUT: 'Провайдер не ответил.',
    PROVIDER_NOT_SELECTABLE: 'Этого провайдера выбрать нельзя.',
    INVALID_STATE_TRANSITION: 'Действие невозможно — статус заявки не подходит.',
    OTP_INVALID: 'Код введён неверно.',
    OTP_EXPIRED: 'Срок действия кода истёк. Запросите новый.',
    OTP_ATTEMPTS_EXCEEDED: 'Попытки исчерпаны. Запросите новый код.',
    AMOUNT_EXCEEDS_LIMIT: 'Сумма превышает одобренный лимит.',
    CONTRACT_FAILED: 'Не удалось оформить договор.',
    ADAPTER_NOT_CONFIGURED: 'Интеграция с провайдером ещё не настроена.',
    NOT_IMPLEMENTED: 'Эта возможность ещё не реализована.',
};
export const ERROR_MESSAGES = {
    uz: ERROR_MESSAGES_UZ,
    ru: ERROR_MESSAGES_RU,
};
export function errorMessage(code, lang = DEFAULT_LANG) {
    const table = ERROR_MESSAGES[lang] ?? ERROR_MESSAGES[DEFAULT_LANG];
    return table[code] ?? table.INTERNAL;
}
//# sourceMappingURL=errors.js.map